import React from 'react';
import {
  HeaderLogo,
  ContactUsLink,
  SearchLink,
  HamburgerMenuLink,
} from 'organisms';

const ProxyHeader = (): React.JSX.Element => {
  return (
    <>
      {/* Header section */}
      <header className='border-bottom'>
        {/* Container for the header */}
        <div className="container-fluid">
          {/* Navigation bar */}
          <nav className="header container-lg d-flex align-items-center justify-content-between">
            <HeaderLogo />
            <div className="d-flex flex-no-wrap align-items-center">
              {/* Contact us link, visible on extra-large and large screens */}
              <div className="d-none d-xl-block d-lg-block d-md-none">
                <ContactUsLink showIcon />
              </div>
              {/* Hamburger menu link, visible on large, medium, and small screens */}
              <div className="d-lg-none d-md-block d-sm-block">
                <HamburgerMenuLink showLogout />
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default ProxyHeader;
